// PAQUETES
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const CLAVE_CIERRE = "zervicy_banner_app_cerrado";
const DIAS_ANTES_DE_VOLVER_A_MOSTRAR = 3;

// El componente se monta una sola vez por plantilla en Direccionamiento.jsx
// (PlantillaGlobal y PlantillaSesion), así que él mismo decide en qué rutas
// NO debe mostrarse: flujo de sesión, checkout/pagos, cuenta privada del
// comprador y /links (esa página es puros links, no necesita el banner encima).
// admin y vendedor quedan excluidos de raíz porque el componente ni se monta ahí.
const RUTAS_EXCLUIDAS = [
    // sesión
    "/iniciar-sesion", "/registrar", "/referido", "/eliminar-datos",
    "/alerta", "/error-inicio-google", "/descargar-beta", "/callback-didit",
    // checkout / pagos
    "/reserva", "/pago", "/respuesta-pago",
    // página de puros links
    "/links",
];

function esRutaDeExploracion(pathname){
    if(RUTAS_EXCLUIDAS.includes(pathname)) return false;
    if(pathname.startsWith("/usuario/")) return false; // cuenta privada del comprador

    return true;
}

// Detecta el sistema operativo desde el user agent. Si no es Android ni iOS
// (ej. desktop), devuelve null y el banner no se muestra.
function detectarSistemaOperativo(){
    const ua = window.navigator.userAgent || window.navigator.vendor || "";

    if(/android/i.test(ua)) return "android";
    if(/iphone|ipad|ipod/i.test(ua)) return "ios";

    return null;
}

function fueCerradoRecientemente(){
    const guardado = window.localStorage.getItem(CLAVE_CIERRE);
    if(!guardado) return false;

    const fechaCierre = Number(guardado);
    if(Number.isNaN(fechaCierre)) return false;

    const diasTranscurridos = (Date.now() - fechaCierre) / (1000 * 60 * 60 * 24);
    return diasTranscurridos < DIAS_ANTES_DE_VOLVER_A_MOSTRAR;
}

function BannerDescargarApp(){

    const location = useLocation();
    const rutaPermitida = esRutaDeExploracion(location.pathname);

    const [urlTienda, setUrlTienda] = useState(null);
    const [visible, setVisible] = useState(false);

    // Se monta una sola vez por plantilla y sigue vivo al navegar entre rutas
    // (el layout no se remonta), así que hay que re-evaluar en cada cambio de ruta.
    useEffect(() => {
        if(!rutaPermitida){
            setVisible(false);
            return;
        }

        const sistemaOperativo = detectarSistemaOperativo();

        // No es un celular Android/iOS, o el usuario ya cerró el banner hace poco.
        if(!sistemaOperativo || fueCerradoRecientemente()) return;

        let cancelado = false;

        // Las URLs de las tiendas viven en backend/funciones/variables.js (versionApp),
        // así que las pedimos en vez de duplicarlas aquí.
        axios.post("/obtener-version-app")
            .then((res) => {
                if(cancelado) return;

                const url = res?.data?.versionApp?.[sistemaOperativo]?.storeUrl;
                if(!url) return;

                setUrlTienda(url);
                setVisible(true);
            })
            .catch(() => {});

        return () => { cancelado = true; };
    }, [rutaPermitida]);

    function cerrarBanner(){
        window.localStorage.setItem(CLAVE_CIERRE, String(Date.now()));
        setVisible(false);
    }

    if(!visible || !urlTienda) return null;

    return (
        <div
            className="d-flex align-items-center gap-2 px-3 py-2"
            style={{ backgroundColor: "var(--color-bg-surface)", borderBottom: "1px solid var(--color-border)" }}
        >
            <button
                type="button"
                className="btn btn-link p-0 text-secondary flex-shrink-0"
                onClick={cerrarBanner}
                aria-label="Cerrar"
                title="Cerrar"
                style={{ textDecoration: "none", fontSize: "18px" }}
            >
                <i className="bi bi-x-lg" />
            </button>

            <img
                src="/imagenes/marca/favicon.ico"
                alt="Zervicy"
                className="rounded flex-shrink-0"
                style={{ width: "36px", height: "36px" }}
            />

            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                <p className="fw-bold mb-0" style={{ fontSize: "13px", color: "var(--color-text-primary)" }}>Zervicy</p>
                <p className="mb-0 text-secondary text-truncate" style={{ fontSize: "12px" }}>
                    Vive la mejor experiencia en la app
                </p>
            </div>

            <a
                href={urlTienda}
                target="_blank"
                rel="noreferrer"
                className="btn btn-sm rounded-pill px-3 flex-shrink-0 fw-semibold"
                style={{ backgroundColor: "var(--naranja-cta)", color: "white", border: "none", fontSize: "12px" }}
            >
                Abrir
            </a>
        </div>
    );
}

export default BannerDescargarApp;
